// Generated by purs version 0.14.3
"use strict";
var $foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/record/v3.0.0/src/Record/Unsafe/Union.js");
var Data_Function_Uncurried = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/functions/v5.0.0/src/Data/Function/Uncurried.purs");
var unsafeUnion = Data_Function_Uncurried.runFn2($foreign.unsafeUnionFn);
module.exports = {
    unsafeUnion: unsafeUnion,
    unsafeUnionFn: $foreign.unsafeUnionFn
};
